const PERMISSION_URL = process.env.API_URL + '/permission/';

const getPermissionsByUser = (context, objectId, objectType) => {
  return context.$http.get(PERMISSION_URL + objectType + '/' + objectId + '/users');
};

const getPermissionsByGroup = (context, objectId, objectType) => {
  return context.$http.get(PERMISSION_URL + objectType + '/' + objectId + '/groups');
};

const addPermission = (context, permissionType, objectId, objectType, userOrGroup, userOrGroupId) => {
  return context.$http.put(PERMISSION_URL + objectType + '/' + objectId + '/' + permissionType + '/' + userOrGroup + '/' + userOrGroupId);
};

const deletePermission = (context, permissionType, objectId, objectType, userOrGroup, userOrGroupId) => {
  return context.$http.delete(PERMISSION_URL + objectType + '/' + objectId + '/' + permissionType + '/' + userOrGroup + '/' + userOrGroupId);
};

export default {
  getPermissionsByUser,
  getPermissionsByGroup,
  addPermission,
  deletePermission
};



// WEBPACK FOOTER //
// ./src/api/permission/permissionHttp.js